// import React from 'react'
// import { Row, Col } from 'antd';
// import { TbDiscount2 } from 'react-icons/tb';
// import { useNavigate } from 'react-router-dom';
// import image from "../../../assets/frontendassets/websiteimages/SECTION8whatnet4surgeoffer.jpg";


// const LestinOffer: React.FC = () => {
//   const navigate = useNavigate();

// const handleEnquiryRedirect = () => {
//   navigate("/listing?category=&state=");
// };
//   return (
//     <>
//     <div className='bg-gray-100'>
//   <Row  className="mt-5">
//   <Col xs={24} sm={24} md={24} lg={10} xl={12} xxl={12} className='pt-6 md:pt-0 pb-6 md:pb-24 pl-4 xl:pl-48 mt-6'>
//     <p className='font-semibold text-lg text-md mb-3 tracking-widest text-yellow'style={{ fontFamily: '"Manrope", sans-serif' }}  >What Net4Surge Offers</p>
//     <p className='text-5xl font-extrabold tracking-tight'style={{ fontFamily: '"Manrope", sans-serif' }}>Grow your business with our platform</p>
//     <p className='pt-3 text-lg text-gray-500'style={{ fontFamily: '"Manrope", sans-serif' }}>At Net4Surge, we provide a comprehensive suite of services designed to elevate your business and ensure your success:</p>
//     <span className="bg-white d-flex justify-between p-4 mt-4 mb-4 border-r-4 border-yellow-700" style={{ backgroundColor: "#f5f5f5" }}>
//   <div className="font-bold text-lg text-yellow"style={{ fontFamily: '"Manrope", sans-serif' }}>
//     Join Net4Surge today and take advantage of these offerings to propel your business to new heights!
//   </div>
// </span>

//     <div className='d-flex align-items-center'>
//       <TbDiscount2 className='text-yellow w-20 h-20 font-light' />
//       <p className='text-black tracking-wider font-bold text-xl pl-2'style={{ fontFamily: '"Manrope", sans-serif' }}>Find the best places in the city for business, activities and relaxation</p>
//     </div>
//     <button className=" font-bold px-14 py-3 rounded-md  mt-5 text-black bg-yellow-700" 
//          onClick={handleEnquiryRedirect} style={{ fontFamily: '"Manrope", sans-serif' }}>
//                 Search Now
//               </button>
//   </Col>
//   <Col xs={24} sm={24} md={24} lg={14} xl={12} xxl={12} className='pt-6 md:block xl:block lg:block md:pt-0   pb-6 sm:hidden xs:hidden  pl-6 md:pl-24 xs:pt-6 '>
//     <img src={image} className=' w-full' style={{ maxWidth : "100%", backgroundPosition : "center" ,  }} alt="Family spending time together outdoors" />
//   </Col>
// </Row>
// </div>
//     </>
//   )
// }

// export default LestinOffer


import React from 'react'
import { Row, Col } from 'antd';
import { TbDiscount2 } from 'react-icons/tb';
import { useNavigate } from 'react-router-dom';
import image from "../../../assets/frontendassets/png images/getstart.png";


const LestinOffer: React.FC = () => {
  const navigate = useNavigate();

  const handleEnquiryRedirect = () => {
    navigate("/listing?category=&state=");
  };
  return (
    <>
      <div className='bg-[#FFF8EC]'>
        <Row>
          <Col span={24} className="mt-2 p-2 lg:px-0 xl:px-36 lg:ps-0 xl:ps-36 md:px-0 md:ps-0">
          <Row align="middle" justify="center" className="mb-1">
      <Col xs={2} sm={8} md={7}>
        <hr className="bg-black m-0" />
      </Col>
      <Col xs={20} sm={8} md={7} className="text-center">
        <span className="text-black text-[20px] uppercase tracking-wide">
          What Net4Surge Offers
        </span>
      </Col>
      <Col xs={2} sm={8} md={7}>
        <hr className="bg-gray-400 m-0" />
      </Col>
    </Row>
          </Col>

          <Col span={24} className="text-center lg:px-0 xl:px-36 lg:ps-0 xl:ps-36 md:px-0 md:ps-0">
            <div className="flex flex-col md:flex-row items-center justify-center mb-3">
              <span className="text-black  text-center text-[30px] tracking-wide md:px-5 mx-3">
                Grow your business with our platform
              </span>
            </div>
          </Col>

          <Col
            xs={24}
            sm={24}
            md={24}
            lg={12}
            xl={12}
            xxl={12}
            className="pt-6 h-[300px] md:h-[440px] md:pt-0 pb-6 md:pb-0 pl-4 xl:px-48 mt-6"
            style={{
              backgroundImage: `url(${image})`,
              backgroundPosition: "center",
            
              backgroundSize: "contain",
              backgroundRepeat: "no-repeat",
              position: "relative", // Add this to make <Col> the positioning context
            }}
          >
            <p
              className="absolute text-center top-[4.5rem] xs:left-[5rem] xxs:left-[2rem] xs:right-[5rem] xxs:right-[2rem] left-[5rem] right-[4.5rem] text-white text-lg sm:text-2xl  md:left-[14rem] md:right-[14rem] md:top-[7rem] lg:left-[7rem] lg:top-[7rem]  lg:right-[7rem] xl:left-[10rem] xl:top-[7rem] xl:right-[11rem] 2xl:left-[14rem] 2xl:top-[7rem] 2xl:right-[14rem]" // Added `left` and `right` to keep text within bounds
              style={{ wordWrap: "break-word", maxWidth: "100%" }} // Ensures text doesn't overflow
            >
              Join Net4Surge today and take advantage of these offerings to propel your business to new heights!
            </p>
          </Col>

          <Col xs={24} sm={24} md={24} lg={12} xl={12} xxl={12} className='pt-6 md:block xl:block lg:block md:pt-0 mb-[5rem]   pb-6 sm:hidden relative top-10'>
            <div className="relative w-full max-w-2xl mx-auto p-6 sm:p-8">
              {/* Black Background */}
              <div className="absolute xs:h-[13rem] top-[4rem] xxs:left-[1rem] xxs:right-[1rem] xxs:w-[18rem] xs:w-[20rem] right-8  md:top-[4rem] md:h-[14rem] md:w-[37rem] md:right-[5rem] lg:top-[4rem] lg:h-[17rem] lg:w-[27rem] lg:right-20 xl:top-[6rem] xl:right-14   xl:w-[36rem] xl:h-[13rem] 2xl:top-[6rem] 2xl:right-14   2xl:w-[39rem] 2xl:h-[13rem]  w-[21rem]   rounded-3xl h-[10rem] bg-[#F9B138] z-0"></div>

              {/* White Card */}
              <div className="relative bg-[#FFF8E9] rounded-3xl p-6 sm:p-8 shadow-lg z-10">
                <div className="space-y-6">
                  <h2 className="text-black text-normal sm:text-normal xs:text-[20px] xxs:text-[20px] md:text-2xl  text-left">
                    At Net4Surge, we provide a comprehensive suite of services designed to elevate your business and ensure your success
                  </h2>
                  <p className="text-black text-base sm:text-xl">
                    Find the best places in the city for business, activities and relaxation
                  </p>
                </div>
              </div>
            </div>

          </Col>
        </Row>
      </div>
    </>
  )
}

export default LestinOffer